<template>
  <teleport to="#modals">
    <div class="modal is-fixed" :class="{ 'is-active': active }">
      <div class="modal-background" @click="this.closeModal()"></div>
      <div class="modal-content has-background-white p-4 container">
        <img src="../assets/img/close.svg" class="is-pulled-right close-button" @click="this.closeModal()" />
        <div class="is-clearfix"></div>

        <div class="columns">
          <div class="column is-12">
            <h1 class="has-text-centered font-arla-strong-regular">Arla kyselykampanjan arvonnan säännöt</h1>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">
              Järjestäjä
            </h2>
            <p class="has-text-centered arlainterface-regular">
              Arla Foods Oy, y-tunnus 2079540-2, osoite: Kotkatie 34, 01150 Söderkulla
              (jäljempänä ”Järjestäjä” tai ”Arla Foods”)
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">
              Ketkä voivat osallistua?
            </h2>
            <p class="has-text-centered arlainterface-regular">
              Arvontaan voivat osallistua kaikki Suomessa pysyvästi asuvat 18 vuotta täyttäneet luonnolliset henkilöt.
              Arvontaan eivät voi osallistua niiden yritysten työntekijät eivätkä heidän kanssaan samassa taloudessa
              asuvat henkilöt, jotka ovat osallistuneet tämän arvonnan suunnitteluun, toteutukseen tai järjestelyihin.
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">
              Miten kampanjaan osallistutaan?
            </h2>
            <p class="has-text-centered arlainterface-regular">
              Kampanjaan voi osallistua täyttämällä sähköpostissa tulleen linkin takana olevan kyselyn. Kaikki
              vastanneet ja pyydetyt tiedot antaneet ovat mukana palkinnon arvonnassa.
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">
              Palkinnot ja niistä ilmoittaminen
            </h2>
            <p class="has-text-centered arlainterface-regular">
              Kaikkien kyselykampanjaan osallistuneiden kesken. <b>Arvomme vastaajien kesken 10 kappaletta 30€ arvoisia
                tuotelahjakortteja.</b>
              <br />

              Lahjakortin voittajalle ilmoitetaan voitosta henkilökohtaisesti hänen antamiaan yhteystietoja käyttäen.
              Mikäli voittaja ei vastaa yhteydenottoon 7 päivän kuluessa, voitto mitätöityy ja Järjestäjällä on oikeus
              arpoa uusi voittaja. Palkinto toimitetaan voittajalle voiton ilmoituksessa mainitulla tavalla.
              Järjestäjällä on oikeus julkaista voittajan etunimi, sukunimen ensimmäinen kirjain ja paikkakunta
              Järjestäjän sivustoilla ja sosiaalisen median kanavissa. Palkintoa ei voi vaihtaa rahaksi tai toiseksi
              palkinnoksi eikä siirtää toiselle henkilölle. Palkinto toimitetaan vain Suomessa sijaitsevaan
              osoitteeseen.
              <br />
              <b>
                Lisäksi kysymme erikseen halukkuutta osallistua jatkossa Arla Aamu+ -tuotekehitykseen.
              </b>
            </p>
            <p>
              Mikäli annatte suostumuksenne tähän, tulemme jatkossakin olemaan teihin yhteydessä mahdollisiin
              tuotetestauksiin ja kuluttajatutkimuksiin liittyen. Suostumus ei velvoita teitä osallistumaan jatkossa
              tuotetestauksiin tai kuluttajakyselyihin
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">
              Henkilötietojen käsittely
            </h2>
            <br />
            <p class="has-text-centered arlainterface-regular">
              Järjestäjä käsittelee osallistujien henkilötietoja kampanjan toteuttamiseksi ja palkintojen
              luovuttamiseksi. Lisätietoja henkilötietojen käsittelystä löytyy Järjestäjän tietosuojaselosteesta.
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">Järjestäjän vastuu</h2>
            <p class="has-text-centered arlainterface-regular">
              Järjestäjä vastaa kampanjaan liittyvästä mahdollisesta arpajaisverosta. Osallistuja vapauttaa Järjestäjän
              sekä kampanjan järjestämisessä mukana olleet mahdolliset muut yhteistyökumppanit vahingosta, joka aiheutuu
              tai jonka väitetään aiheutuneen osallistumisesta tähän kampanjaan. Järjestäjän vastuu osanottajia kohtaan
              ei ylitä näissä säännöissä mainittujen palkintojen arvoa tai määrää. Järjestäjä ei vastaa tietoteknisistä
              syistä johtuvista ongelmista tai esteistä kampanjaan osallistumiseen tai palkinnon vastaanottamiseen.
            </p>
            <br />
            <h2 class="has-text-centered font-arla-strong-regular font-18">Muut ehdot</h2>
            <p class="has-text-centered arlainterface-regular">
              Jos kampanjaan osallistujaa on syytä epäillä vilpistä tai osallistumisesta muuten kuin säännöissä
              mainituin tavoin, on Järjestäjällä oikeus hylätä osallistuminen. Järjestäjä ilmoittaa kampanjasivuilla ja
              mahdollisuuksien mukaan kampanjan markkinointikanavissa, mikäli joudumme tekemään muutoksia kampanjaan,
              sen palkintoihin, ajankohtaan, saatavuuteen tai muihin seikkoihin, jotka vaikuttavat kampanjan
              toteutukseen.
              Järjestäjä pidättää itsellään oikeuden tehdä kampanjaan ja sääntöihin sellaisia muutoksia, jotka eivät
              vaikuta olennaisesti osallistujaan.
            </p>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "LotteryRulesModal",
  components: {},
  data() {
    return {
      active: false,
    };
  },
  methods: {
    closeModal() {
      this.active = false;
    },
    showModal() {
      this.active = true;
    },
  },
};
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;

.modal {
  .modal-content {
    background-color: $pale-yellow !important;
  }

  .close-button {
    cursor: pointer;
  }
}

h1 {
  font-size: 45pt;
  color: $dark-green;
}

h2 {
  color: $dark-green;
}

p {
  font-size: 18pt;
}


@media only screen and (max-width: 768px) {
  h1 {
    font-size: 35pt;
    color: $dark-green;
  }

  h2 {
    color: $dark-green;
  }

  p {
    font-size: 15pt;
  }
}
</style>
